module.exports = __webpack_public_path__ + "media/images/application/template/footer-logo-5-7c9a6cd74ea884713e559cc6b1108ac7.png";